<div class="acc-order-details">

  <section>
    <section class="col-12 col-sm-12 col-md-12" class="collabortion-outlet">
      <div class="col-xs-4 col-sm-12 col-md-7">
        <h3 class="monograph-Title">
          {{'collaboration.internal'|cxTranslate}}
        </h3>
      </div>
      <hr class="hr-Style" />
      <div>
        @for (prod of collaborationData; track prod) {
          <div class="panel-group" id="accr-new">
            <div class="panel panel-default">
              <div class="panel-heading">
                <div class="firstLevel-loc product-text-img">
                  <a href="{{prod?.fileMediaUrl}}" target="_blank" class="pdf-Style" data-di-id="di-id-61494698-8d975ab0">
                    <label class="prod-Name">{{ prod?.name}}</label>
                    @if (prod?.fileFormat === 'pdf') {
                      <span>
                      <img src="/icons/pdf.png" alt="pdf" />Pdf</span>
                    }
                    @if (prod?.fileFormat === 'pptx') {
                      <span>
                        <img src="/icons/ppt.png" alt="ppt" />
                      Pptx </span>
                    }
                    @if (prod?.fileFormat === 'xlsx'|| prod?.fileFormat === 'xlsb') {
                      <span>
                        <img src="/icons/xl.png" alt="excel" />
                        @if (prod?.fileFormat === 'xlsx') {
                          <spn>Xlsx</spn>
                        }
                        @if (prod?.fileFormat === 'xlsb') {
                          <span>Xlsb</span>
                        }
                      </span>
                    }
                    @if (prod?.fileFormat === 'doc') {
                      <span>
                        <img src="/icons/word.png" alt="excel" />
                      Doc</span>
                    }
                  </a>
                  <div class="sub-text">{{ prod?.description}}</div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </section>
  </section>
</div>
